<template>
  <LegalPage
    title="About Us"
    intro="gbwhatsdroid.com is an independent information resource focused on helping Android users understand GBWhatsApp before downloading an APK."
    :sections="sections"
    email="contact@gbwhatsdroid.com"
    page-name="about"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'About',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'What This Site Provides',
          paragraphs: [
            'We publish practical information about GBWhatsApp APK downloads, installation steps, feature comparisons, updates, and commonly asked questions.',
            'The site is intended as a reference point. It is not a messaging service, an official support center, or a developer page for GBWhatsApp.',
          ],
        },
        {
          heading: 'Our Approach',
          items: [
            'Keep download guidance easy to follow for Android users.',
            'Separate factual information from third-party download sources.',
            'Highlight risks and limitations instead of promising absolute safety.',
            'Point visitors to the site contact address when more information is needed.',
          ],
        },
        {
          heading: 'What We Are Not',
          paragraphs: [
            'We are not affiliated with WhatsApp Inc., Meta, or the developers of GBWhatsApp. We do not claim to provide official software support, legal advice, or a warranty for any APK linked from this website.',
            'Visitors should make their own decision about whether a third-party modified app is suitable for their device and account.',
          ],
        },
      ],
    };
  },
};
</script>
